import { Component, OnInit  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { page } from '../class/status';
import { Rtable } from '../class/rtabledata';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-withdrawrecord',
  templateUrl: './withdrawrecord.component.html',
  styleUrls: ['./withdrawrecord.component.css']
})
export class WithdrawrecordComponent implements OnInit {

  constructor(
    public httpClient: HttpClient,
  ){}

  ngOnInit(): void {
    this.init_attributes();
    this.init_list();
  }
  money:string = '0';
  search_model:string = '';
  data:any=[];
  edit_data:any=[];
  choose_data:{name:string,money:number}={name:'blue',money:123};
  loading:boolean=true;
  pageobj:page = {page:0,count:20,total_count:0};
  pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
  posts_input:any=[];
  link:string = environment.link;
  tcontent = [
    {title:'姓名',content:'name',type:2},
    {title:'大頭貼',content:'profile_pic',type:1},
    {title:'總提領金額',content:'total_money',format:'number'},
    {title:'剩餘鑽石數金額',content:'diamond',format:'number'},
    {title:'觀看提領紀錄',content:'gg',type:3},
  ];

  init_attributes(){}

  init_list(){
    this.loading = true;
    const body = {page: this.pageobj.page,count:this.pageobj.count,
      search:this.search_model,
    };
    this.httpClient.post<any>("/v1/common/get_withdrawal.php",body).subscribe(res => {
      this.loading = false;
      this.money = res.money;
      if(res.status){
        this.data = res.data;
        this.pageobj.total_count = res.total_count
      }else{
        this.pageobj.total_count = 0
        this.data = [];
      }

      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
    });
  }

  callback(pageobj:page){
    if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
      this.pageobj = pageobj;
      this.init_list();
    }
  }

  choose(id:number){
    this.loading = true;
    const body = {uid:id};
    this.httpClient.post<any>("/v1/common/get_withdrawal.php",body).subscribe(res => {
      this.loading = false;
      if(res.status){
        this.edit_data = res.data;
      }else{
        this.edit_data = [];
      }
    });
  }
}
